import { cx } from "@emotion/css";
import type { UIMessage } from "ai";
import { Info } from "lucide-react";
import { useTranslation } from "react-i18next";
import { renderAiText } from "src/components/AI/AIChatbot";
import { Tooltip } from "src/components/Default/LekUI/Tooltip";
import { ChatbotThinkingBubble } from "src/components/GlobalChatbot/ChatbotThinkingBubble";
import type { ChatbotMessageMetadata } from "src/components/GlobalChatbot/types";
import { getMessageText } from "src/helpers/aiMessage";

interface MessageBubbleProps {
	message: UIMessage;
}

export const MessageBubble = ({ message }: MessageBubbleProps) => {
	const { t } = useTranslation();
	const isUser = message.role === "user";
	const text = getMessageText(message);
	const questionPreview = (
		message.metadata as ChatbotMessageMetadata | undefined
	)?.questionPreview;

	// Pusta odpowiedź = tura wciąż generowana po stronie backendu (response: null).
	if (!isUser && !text) {
		return <ChatbotThinkingBubble />;
	}

	return (
		<div
			className={cx("chatbot-message-row", {
				"chatbot-message-row--user": isUser,
			})}
		>
			<div
				className={cx("chatbot-bubble", {
					"chatbot-bubble--user": isUser,
					"chatbot-bubble--bot": !isUser,
					"chatbot-bubble--with-question": !!questionPreview,
				})}
			>
				<div className="chatbot-bubble-text">{renderAiText(text)}</div>
				{questionPreview && (
					<Tooltip
						title={
							<>
								<div className="chatbot-attached-question-label">
									{t(
										"globalChatbot.attachedQuestion.label",
										"Pytanie ze strony",
									)}
								</div>
								{questionPreview}
							</>
						}
						enterTouchDelay={0}
						leaveTouchDelay={8000}
						wrapperClassName="chatbot-bubble-question-icon"
					>
						<Info
							className="icon-super-small"
							data-test-id="global-chatbot-message-question-icon"
						/>
					</Tooltip>
				)}
			</div>
		</div>
	);
};
